export default __webpack_public_path__ + "static/media/gallery_03.c775ee92.jpg";